import { z } from 'zod';
/**
 * Dossier submission (POST /financing-requests/:id/submit).
 *
 * Consent is non-negotiable: both Datenschutz and Weitergabe an
 * Finanzierungspartner must be explicitly granted, together with the exact
 * consent text version the customer saw. The backend logs both as
 * consent_records (purpose privacy_policy / bank_transfer) with timestamp and
 * IP hash BEFORE flipping the request status.
 */
export const dossierSubmitSchema = z.object({
    consent: z.object({
        privacyPolicy: z.literal(true),
        bankTransfer: z.literal(true),
        /** Version tag of the consent texts the customer accepted, e.g. "2026-06-v1". */
        documentVersion: z.string().trim().min(1).max(64),
    }),
    remarks: z.string().trim().max(2000).optional(),
});
